// extracted by mini-css-extract-plugin
export default {"homeButton":"WaterChapel_homeButton__DcCYj","mapButton":"WaterChapel_mapButton__zBN7E","button":"WaterChapel_button__yaXZF"};